import { type OrderingLedger } from '../machine';

export function prepareLedger(params: PrepareLedgerParams) {
  const { ledger, tip, availableCredit, shouldUseCredit, shouldUseFlex, amountEligibleForFlex } =
    params;

  const initialTotal = sumLedger({ ledger, tip, credit: 0 });

  const flexToBeApplied = Math.min(initialTotal, amountEligibleForFlex);
  const flex = shouldUseFlex ? flexToBeApplied : 0;
  const totalWithFlex = initialTotal - flex;

  const creditToBeApplied = Math.min(totalWithFlex, availableCredit);
  const credit = shouldUseCredit ? creditToBeApplied : 0;

  const subtotal = ledger?.subtotal ?? 0;
  const discountTotal = ledger?.discountsTotal ?? 0;

  const total = sumLedger({ ledger, tip, credit });
  const amountPaidWithStripe = Math.max(total - flex, 0);

  return { total, subtotal, discountTotal, credit, creditToBeApplied, amountPaidWithStripe };
}

function sumLedger(params: SumLedgerParams) {
  const { ledger, tip, credit } = params;

  if (!ledger) return 0;

  return (
    Number(ledger.subtotal ?? 0) +
    Number(ledger.tax ?? 0) +
    tip +
    Number(ledger.feesTotal ?? 0) -
    credit -
    Number(ledger.discountsTotal ?? 0)
  );
}

type PrepareLedgerParams = {
  ledger: Partial<OrderingLedger> | undefined;
  tip: number;
  availableCredit: number;
  amountEligibleForFlex: number;
  shouldUseCredit: boolean;
  shouldUseFlex: boolean;
};

type SumLedgerParams = {
  ledger: Partial<OrderingLedger> | undefined;
  tip: number;
  credit: number;
};
